module.exports = __webpack_public_path__ + "static/media/ab3.7f00757e.png";